
/* Single image */
import img1 from '../images/service/injsra.jpg'
import img2 from '../images/service/download1.png'
import img3 from '../images/service/berberie.png'
import img4 from '../images/service/species.png'

import sion1 from '../images/service/icon-1.svg'
import sion2 from '../images/service/icon-2.svg'
import sion3 from '../images/service/icon-3.svg'
import sion4 from '../images/service/icon-4.svg'
import Simg1 from '../images/product/white injera.jpg'
import Simg2 from '../images/service/species.png'
import Simg3 from '../images/service-single/img3.jpg'
import Simg4 from '../images/service-single/img3.jpg'

const Services = [
    {
        id: 1,
        icon: sion1,
        simage: img1,
        imag: Simg1,
        title: '100% pure Teff injera',
        description: 'We have more doctor for your dental illness. We are here for your better treatment',
        slug: 'injera'
    },
    {
        id: 2,
        icon: sion2,
        simage: img2,
        imag: Simg2,
        title: 'Catering Services',
        description: 'We have more doctor for your dental illness. We are here for your better treatment',
        slug: 'catering services'
    },
    {
        id: 3,
        icon: sion3,
        simage: img3,
        imag: Simg3,
        title: 'Spices & Ingredients',
        description: 'We have more doctor for your dental illness. We are here for your better treatment',
        slug: 'spices and ingredients'
    },
    {
        id: 4,
        icon: sion4,
        simage: img4,
        imag: Simg4,
        title: 'Household Needs',
        description: 'We have more doctor for your dental illness. We are here for your better treatment',
        slug: 'household needs'
    }
   


];
export default Services;